import { SimpleTokenFactory } from './simple-token.factory';
import { Asset, TokenPrice, TokenValue } from '../model';
import { AssetDto, AssetListResponseDto } from '../dto';

export class AssetFactory {
  public static convertDtoList(listResponseDto: AssetListResponseDto): Asset[] {
    return listResponseDto.items.map(dto => AssetFactory.convertDto(dto));
  }

  public static convertDto(dto: AssetDto): Asset {
    return new Asset(
      SimpleTokenFactory.createFromDto(dto.token),
      dto.balance ? BigInt(dto.balance) : 0n,
      new TokenPrice(
        dto.priceInNativeCurrency
          ? BigInt(dto.priceInNativeCurrency)
          : undefined,
        dto.priceInUsd,
      ),
      new TokenValue(
        dto.valueInNativeCurrency
          ? BigInt(dto.valueInNativeCurrency)
          : undefined,
        dto.valueInUsd,
      ),
      dto.isTradeable,
      dto.isSellable,
    );
  }
}
